import { Field } from "formik";
import PasswordField from "../components/PasswordField/PasswordField";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormPasswordInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  ...props
}) => {
  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <Field
      name={name}
      as={PasswordField}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      {...(typeof onChange === "function" ? { onChange } : {})}
      {...props}
    />
  );
};

export default FormPasswordInput;
